import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Seo from "../components/Seo";
import { API } from "../context/AuthContext";

const abs = (u) => (u && u.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${u}` : u);

export function renderBody(body) {
  return body.split(/\n{2,}/).flatMap(b => { const m = b.match(/^(#{1,2} [^\n]+)\n([\s\S]+)$/); return m ? [m[1], m[2]] : [b]; }).map((block, i) => {
    const img = block.match(/^!\[(.*?)\]\((.+?)\)$/);
    if (img) return <img key={i} src={abs(img[2])} alt={img[1]} className="rounded-xl max-h-[420px] object-contain my-6" />;
    if (block.startsWith("## ")) return <h2 key={i} className="font-display font-black text-2xl mt-8 mb-3">{block.slice(3)}</h2>;
    if (block.startsWith("# ")) return null;
    const btn = block.match(/^\[(.+?)\]\((mailto:[^)]+|\/[^)]*|https?:[^)]+)\)$/);
    if (btn) return <p key={i} className="pt-2"><a href={btn[2]} className="btn-crimson inline-flex items-center min-h-[48px]" data-testid="info-page-cta">{btn[1]}</a></p>;
    if (block.split("\n").every(l => l.startsWith("- "))) return <ul key={i} className="list-disc pl-6 space-y-1 text-slate-300">{block.split("\n").map((l, j) => <li key={j}>{l.slice(2)}</li>)}</ul>;
    return <p key={i} className="text-slate-300 leading-relaxed whitespace-pre-line">{block.split(/(\*\*[^*]+\*\*)/).map((s, j) => s.startsWith("**") ? <b key={j} className="text-white">{s.slice(2, -2)}</b> : s)}</p>;
  });
}

export default function InfoPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); axios.get(`${API}/site/pages/${slug}`).then(r => setPage(r.data)).catch(() => setErr(true)); }, [slug]);
  return (
    <div className="min-h-screen grain-bg">
      <Navbar />
      <section className="pt-28 pb-20 max-w-3xl mx-auto px-5">
        {err && <div className="rl-card p-10 text-center text-slate-500" data-testid="page-not-found">Pagina non trovata. <Link to="/" className="text-[#FF9F0A]">Torna alla home</Link></div>}
        {page && (
          <article data-testid={`info-page-${page.slug}`}>
            {page.image && <img src={abs(page.image)} alt="" className="w-full max-h-72 object-cover rounded-2xl mb-8" />}
            <Seo title={`${page.title} | Rally Love`} description={(page.body || "").replace(/[#*]/g, "").slice(0, 155)} />
            <h1 className="headline-huge text-4xl sm:text-5xl mb-2" data-testid="info-page-title">{page.title}</h1>
            {page.version && <div className="text-[11px] font-mono-rl text-slate-500 mb-6" data-testid="info-page-version">VERSIONE {page.version} · PUBBLICATO IL {page.published_at} · IN VIGORE DAL {page.effective_at}</div>}
            <div className="space-y-4">{renderBody(page.body || "")}</div>
          </article>
        )}
      </section>
    </div>
  );
}
